<div class="app-c-text-area" [ngClass]="customClass">
  <textarea
  [value]="value"
    [id]="id"
    [attr.placeholder]="placeholder"
    [disabled]="disabled"
    #textareaRef
    [class.limit-exceeded]="isAtLimit"
    (input)="onInput($event);adjustHeight()"
  ></textarea>
  <ng-content></ng-content>
</div>
<div class="char-count-wrapper" *ngIf="showCharCount && isAtLimit">
  <span class="limit-message">{{ validationMessage }}</span>
</div>